import React, { Component } from 'react';

export default class Spinners extends Component {
  render() {
    return (
      <span
        class="spinner-border spinner-border-sm mr-2"
        role="status"
        aria-hidden="true"
      ></span>
    );
  }
}
